<template>
  <div class="flex column between stretch fill">
    <div v-if="!single" class>
      <div class="flex between align-center">
        <div class="p8">
          <i class="r16 far fa-envelope update-text"></i>
          <i class="fas fa-search r16" @click="
              $set($store.state.show, 'findMsg', !$store.state.show.findMsg)
            "></i>
        </div>
        <input v-if="$store.state.show.findMsg" class="r16 xs-input flexy xs-font" type="text" v-model="searchMessages"
          placeholder="Find Message" />
        <div class="p8">
          <i v-if="!$store.state.show.findMsg" class="fas fa-plus r16" @click="
              $set(
                $store.state.show,
                'newMessage',
                !$store.state.show.newMessage
              )
            "></i>
        </div>
      </div>
    </div>

    <div class="flexw flex wrap" style="overflow: scroll; -webkit-overflow-scrolling: touch; height: 100%">
      <div class="flex column sub-container around flexw" v-if="$store.state.show.newMessage">
        <div class="flex between align-center b4">
          <i @click="
              $set(
                $store.state.show,
                'newMessage',
                !$store.state.show.newMessage
              )
            " class="fas fa-chevron-left"></i>
          <b class="sm-font">New Message</b>
        </div>
        <i></i>
        <div class="sm-font flex wrap b4 p4 align-center" :class="newMsgUsers.length < 1 ? 'indicate' : ''">
          <b>TO: </b>
          <div class="flex align-center">
            <input autofocus="true" class="xs-font sm-input r4" type="text" v-model="searchUser"
              placeholder="Search for people" />
          </div>
          <div class="flex align-center ml8 position-relative">
            <select v-model="selectedUser" @change="onUserSelect" class="xs-font sm-input r4" style="min-width: 200px;">
              <option value="" disabled>Select user to add</option>
              <option v-for="(user, userId) in $store.state.userlist" :key="userId" :value="userId"
                :disabled="newMsgUsers.includes(userId)">
                {{ user.basics?.name || user.email || userId }}
              </option>
            </select>
          </div>
          <div @click="
              newMsgUsers.indexOf(userKey) > -1
                ? newMsgUsers.splice(newMsgUsers.indexOf(userKey), 1)
                : newMsgUsers.push(userKey)
            " :key="userKey" v-for="(user, userKey) in $store.state.ref.name">
            <div :style="
                newMsgUsers.indexOf(userKey) > -1
                  ? 'border: 1px solid white; padding: 2px;'
                  : ''
              " :class="`wrap flex align-center r4 sm-font p4`" class="flex center" v-if="
                (user.toLowerCase().indexOf(searchUser.toLowerCase()) > -1 &&
                  searchUser.length > 0) ||
                newMsgUsers.indexOf(userKey) > -1
              ">
              <user :userid="userKey" nolink="true" />
            </div>
          </div>
        </div>
        <div class="flex stretch wrap between align-center">
          <textarea class="b4" :placeholder="`Type message`" v-model="newMsg"></textarea>
          <input class="sm-input xs-font b4" type="text" placeholder="Set topic" v-model="newTopic['new message']" />
          <button :disabled="newMsg.length < 1" type="button" class="success" @click="
              message(newMsg, newMsgUsers, newTopic['new message']);
              newMsg = '';
              newTopic['new message'] = '';
              $set($store.state.show, 'newMessage', false);
            ">
            <i class="fas fa-paper-plane fa-2x p16"></i>
          </button>
        </div>
      </div>
      <div class="flexy sub-container flex column" :key="'messages' + $store.state.componentKeys.message" v-if="
          $store.state.user[$store.state.auth.uid] &&
          $store.state.user[$store.state.auth.uid].msgs &&
          $store.state.msgs
        ">
        <div class="flex column flexy b8" :key="msgKey" v-for="(msg, msgKey) in msgid || topic ? custommsgs : messages"
          :style="{ order: order.indexOf(msgKey) }">
          <div @click="
              $store.state.user[$store.state.auth.uid].msgs[msgKey] === 'unseen'
                ? (($store.state.user[$store.state.auth.uid].msgs[
                    msgKey
                  ] = true),
                  $store.dispatch('update', {
                    type: 'user',
                    id: $store.state.auth.uid,
                    data: $store.state.user[$store.state.auth.uid],
                  }),
                  $store.state.counts.messages--)
                : ''
            " v-if="
              searchMessages.length === 0 ||
              JSON.stringify(msg)
                .toLowerCase()
                .indexOf(searchMessages.toLowerCase()) > -1
            ">
            <div class="align-center">
              <div class="flex align-center flexy between">
                <div class="flex p4 fa-sm align-center flexy r4 wrap" @click="
                    $set(show, msgKey, !show[msgKey]);
                    show[msgKey] && scrollto(msgKey);
                  ">
                  <i :class="`r8 fas fa-xs fa-${
                      !show[msgKey] ? 'plus' : 'minus'
                    }-square`"></i>
                  <span class="xs-font" v-for="(user, userKey) in msg.users" :key="userKey">
                    <user v-if="user !== $store.state.auth.uid" nolink="true" :userid="user" display-size="16"
                      class="r8"></user>
                  </span>
                  <b v-if="snips[msgKey] && msg.banter[snips[msgKey]]" class="xs-font">{{
                    msg.banter[snips[msgKey]].text.substring(0, 70)
                    }}{{
                    msg.banter[snips[msgKey]].text.length > 70 ? "..." : ""
                    }}</b>
                </div>
                <i class="xs-font p4 ">Type: {{ msg.type ? msg.type.toUpperCase() : '' }}</i>
                <b class="xs-font" @click="$set(setTopic, msgKey, !setTopic[msgKey])">
                  <i class="fas fa-tag r4"></i>
                  {{ msg.topic || "Set topic?" }}
                </b>
                <button @click="$set(show,'id' + msgKey, true)" type="button" class="fa fa-copy fa-xs"></button>
                <rm class="xs-font" :item="{type: 'msgs', id: msgKey}" title="message" msg="" />
                <div v-if="show['id' + msgKey]">{{msgKey}}</div>
              </div>
              <div v-if="setTopic[msgKey]" class="flex align-center">
                <input autofocus class="sm-input xs-font r4" type="text" placeholder="Set msg topic"
                  v-model="newTopic[msgKey]" />
                <button :class="newTopic[msgKey] ? 'success' : ''" type="button" :disabled="!newTopic[msgKey]">
                  <i class="fas fa-check-circle fa-xs" @click="
                      $store.dispatch('update', {
                        type: 'msgs',
                        topic: newTopic[msgKey],
                        mId: msgKey,
                      });
                      newTopic[msgKey] = '';
                      setTopic[msgKey] = !setTopic[msgKey];
                    "></i>
                </button>
              </div>
            </div>
            <div v-if="show[msgKey] || single">
              <div class="flex align-center wrap between">
                <textarea :ref="'response' + msgKey" :key="'response' + msgKey + Object.keys(msg.banter).length"
                  v-model="response[msgKey]" class="with-button flexw md-font b8" type="text"
                  placeholder="reply"></textarea>
                <button v-if="response[msgKey]" :disabled="response[msgKey].length < 1" type="button" @click="
                    $set(snips, msgKey, '');
                    order.slice(order.indexOf(msgKey), 1);
                    order.unshift(msgKey);
                    $store
                      .dispatch('update', {
                        type: 'msgs',
                        text: response[msgKey],
                        mId: msgKey,
                      })
                      .then((dateid) => {
                        $set(snips, msgKey, dateid);
                      });
                    response[msgKey] = '';
                    scrollto(msgKey);
                  " class="update p16 m16">
                  <i class="fas fa-paper-plane fa-2x"></i>
                </button>
              </div>
              <div style="
                  border-left: 1px solid rgba(0, 0, 0, 0.1);
                  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
                  max-height: 66vh;
                " class="flex column flexy p4 container v-scroll">
                <div v-for="(bant, bantKey) in Object.fromEntries(
                    Object.entries(msg.banter).sort((a, b) => +b[0] - +a[0])
                  )" :key="bantKey" class="flex fill b8" :ref="msgKey + 'bant' + bantKey">
                  <div class="flexy fill p4">
                    <div class="flex between align-center b4 p4 wrap xs-font fill">
                      <b>
                        <user :userid="bant.user" display-size="22"></user>
                      </b>
                      <span class="flex align-center">
                        <reputation :key="
                            $store.state.componentKeys.message + msgKey + bantKey
                          " class="xs-font" :fId="msgKey + '-' + bantKey" :fSuper="msgKey" fType="msgs"></reputation>
                        <itime class="l4" gran="minute" :timestamp="Math.floor(bantKey)"></itime>
                      </span>
                    </div>
                    <div :class="'sub-container p16'" class="flex wrap align-center between">
                      <icontent style="text-justify: left" :content="bant.text" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import Vue2Filters from "vue2-filters";
import rm from "../uxui/rm.vue";

export default {
  components: {
    rm,
  },
  props: {
    msgid: { type: String },
    topic: { type: String },
  },
  computed: {
    messages: {
      get(){return this.single ? {[this.single] : this.$store.state.msgs[this.single]} : this.$store.state.msgs},
      set(){return}
    }
  },
  data() {
    return {
      selectedUser: '',

      controls: ["new", "share"],
      order: [],
      findMsg: false,
      name: "message",
      newMsg: "", 
      newMsgUsers: [],
      newTopic: {},
      poppedMessage: {},
      response: {},
      searchMessages: "",
      searchUser: "",
      setTopic: {},
      single: false,
      show: {},
      custommsgs: [],
      snips: {},
    };
  },
  methods: {
    onUserSelect() {
      if (this.selectedUser && !this.newMsgUsers.includes(this.selectedUser)) {
        this.newMsgUsers.push(this.selectedUser);
        this.selectedUser = '';
      }
    },
    scrollto(msgid) {
      this.$nextTick(() => {
        let st = this.$refs["response" + msgid];        
        st[0].focus();
      });
    },
    log(x) {
      console.log(x);
    },
    message(msg, users, topic) {
      var msgUsers =
        users.indexOf(this.$store.state.auth.uid) > -1
          ? users
          : [this.$store.state.auth.uid, ...users];
      var msgObj = {
        type: "msg",
        data: {
          banter: {
            [Date.now()]: {
              text: msg,
              user: this.$store.state.auth.uid,
            },
          },
          type: "dm",
          topic,
          users: msgUsers,
        },
      };
      return this.$store.dispatch("create", msgObj).then((newmsgid) => {
        this.$set(
          this.$store.state.componentKeys,
          "message",
          this.$store.state.componentKeys.message + 1
        );
        this.getmessages()
        return newmsgid;
      });
    },
    respond(comment, message, user) {
      this.messages[message.id].comments.push({
        user,
        comment,
        timestamp: Date.now(),
      });
    },
    async getmessages() {
      if(this.$store.state.user[this.$store.state.auth.uid]){
        let retmessages = this.$store
        .dispatch("query", { type: "msgs" })
        .then((msgz) => {
          this.single = this.msgid || this.$route.params.messageid
          let msgorder = {};
          Object.entries(msgz).map((x) => {
            msgorder[x[0]] = +Object.keys(x[1].banter).sort((a, b) => +a - +b)[
              Object.keys(x[1].banter).length - 1
            ];
            this.getspecific();
            this.$set(this.snips, x[0], msgorder[x[0]]);
          });
          this.$set(
            this,
            "order",
            Object.entries(msgorder)
              .sort((a, b) => {
                return +b[1] - +a[1];
              })
              .map((x) => x[0])
          );
          return msgz;
        });
      return await this.$set(this, 'messages', retmessages);
      } else {
        setTimeout(()=>{
          this.getmessages()
        }, 1000)
      }
      
    },
    async getspecific() {
      if (this.msgid || this.$route.params.messageid) {
        let id = this.msgid || this.$route.params.messageid
        if (this.$store.state.msgs[id]) {
          this.custommsgs.push(this.$store.state.msgs[id]);
        } else {
          let newmsgid = this.message(
            "Please write your message and we will be in touch soon.",
            [this.$store.state.app.owner]
          );
          this.custommsgs.push(this.$store.state.msgs[await newmsgid]);
        }
      }
      if (this.topic) {
        let messages = JSON.parse(JSON.stringify(this.$store.state.msgs));
        let topicmsgs = [];
        Object.entries(await messages).forEach((x) => {
          x[1].topic.toLowerCase() === this.topic.toLowerCase()
            ? topicmsgs.push(x)
            : null;
        });
        if (!topicmsgs || topicmsgs.length === 0) {
          this.message(
            "Please write a message here and we'll respond soon as possible.",
            [this.$store.state.app.owner],
            this.topic
          );
        } else {
          this.custommsgs = Object.fromEntries(topicmsgs);
        }
      }
    },
  },
  mixins: [Vue2Filters.mixin],
  name: "message",
  watch: {
    "this.$store.state.msgs": {
      handler: async function () {
        this.getmessages();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style>

.comment-meta {
  color: rgba(0, 0, 0, 0.4);
}
.margin-right-16 {
  margin-right: 16px;
}

.message-left {
  flex: 0 1 auto;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.message-right {
  flex: 3 1 auto;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 8px;
  background: rgba(255, 255, 255, 0.6);
  color: black;
  margin-right: 4px;

}
.message-group {
  height: 48px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.4);
  margin: 4px 0;
}
.message-chevron {
  margin-right: 4px;
}
.message-group-selected {
  height: 48px;
  background: rgba(255, 255, 255, 0.6);
  color: black;
  border-bottom: 2px solid rgba(255, 255, 255, 0.4);
  margin: 4px 0;
}
.message-name {
  margin-left: 4px;
}
.reply {
  min-height: 96px;
}
</style>
